import React, { useState } from "react";
import { FiCopy, FiCheckCircle } from "react-icons/fi";

const PasswordPopup = ({ password, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset setelah 2 detik
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-md p-6 bg-white shadow-lg rounded-2xl animate-fade-in">
        <div className="flex items-center gap-2 mb-4 text-green-700">
          <FiCheckCircle className="text-2xl" />
          <h2 className="text-xl font-semibold">Akun Berhasil Dibuat</h2>
        </div>

        <p className="mb-2 text-gray-700">
          Berikut adalah password untuk pengguna:
        </p>

        <div className="flex items-center justify-between px-4 py-2 border border-green-300 rounded-lg bg-green-50">
          <span className="font-mono text-green-800">{password}</span>
          <button
            type="button"
            onClick={handleCopy}
            title="Copy Password"
            className={`p-1 transition-colors ${
              copied
                ? "text-red-600 hover:text-red-700"
                : "text-green-600 hover:text-green-800"
            }`}
          >
            <FiCopy className="w-5 h-5" />
          </button>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="w-full px-4 py-2 mt-6 font-semibold text-white bg-green-600 rounded-lg hover:bg-green-700"
        >
          Tutup
        </button>
      </div>
    </div>
  );
};

export default PasswordPopup;
